import script from "./ProfileSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSelector.vue?vue&type=style&index=0&id=d50bfa36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d50bfa36"]])

export default __exports__